import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { ComponentPageTitle } from '../../page-title/page-title.component';
import { AppServiceService } from '../../services/app-service.service';
import { MatPaginator, MatTableDataSource, MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatSnackBar, PageEvent } from '@angular/material';
import { CreateMensajeriaComponent } from 'src/app/home/mensajeria-masiva/create-mensajeria/create-mensajeria.component';
import { CreateScheduleComponent } from 'src/app/home/create-schedule/create-schedule.component';
import { CreateAlarmaComponent } from 'src/app/home/create-alarma/create-alarma.component';
import { CreateCriterioComponent } from 'src/app/home/create-criterio/create-criterio.component';
import { GatewayService } from 'src/app/gateway.service';
import { Subscription } from 'rxjs/Subscription';
import { BusquedaService } from '../busqueda.service';
import { CreateService } from '../createservice';
import { CreateCicloComponent } from 'src/app/home/create-ciclo/create-ciclo.component';
import { FiltroPaisService } from '../filtro-pais.service';
import { LocalSaveService } from 'src/app/services/local-save-service.service';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { NgxSpinnerService } from 'ngx-spinner';
import { ConfirmacionComponent } from '../confirmacion/confirmacion.component';
import { PasswordnewComponent } from 'src/app/login/passwordnew/passwordnew.component';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
	selector: 'app-mensajeria-masiva',
	templateUrl: './mensajeria-masiva.component.html',
	styleUrls: ['./mensajeria-masiva.component.scss']
})
export class MensajeriaMasivaComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();

	displayedColumns = ['NOMBRE', 'FECHA_CREACION', 'TIPO', 'ACCION'];
	dataSource = new MatTableDataSource<any>([]);
	FILTER: string = '';
	resultsLength: number = 0;
	pageSize = 10;
	private subscription: Subscription;
	private subscriptioncreate: Subscription;
	private subscriptionpais: Subscription;
	idpais = 5;
	pageEvent: PageEvent;
	public actpage: number = 0;

	// MENSAJERIA
	actpagecampana: number = 0;
	filtercampana: string = '';
	criterioindex: number = 0;

	constructor(
		private router: Router,
		private snackbar: MatSnackBar,
		private gateway: GatewayService,
		public pageTitle: ComponentPageTitle,
		public _appservice: AppServiceService,
		public _busqueda: BusquedaService,
		public _create: CreateService,
		private dialog: MatDialog,
		public _filtroPais: FiltroPaisService,
		private localSave: LocalSaveService,
		private spinner: NgxSpinnerService
	) { }

	@ViewChild('mensajeriapaginator') mensajeriapaginator: MatPaginator;

	ngOnInit() {
		const user = this.localSave.get('usuarioPGV');
		if (!user || user.idrol != 1) {
			this.router.navigate(['/home']);
		}
		this.idpais = this.localSave.get('pais');
		this.get(0);
		this.pageTitle.title = 'Mensajeria masiva';
		// this.loadUsuarios();
		this.subscription = this._busqueda.notifyObservable$.pipe(takeUntil(this.destroy$)).subscribe(
			res => {
				this.filtrarcampana(res.filtro);
			});
		this.subscriptioncreate = this._create.notifyObservable$.pipe(takeUntil(this.destroy$)).subscribe(
			res => {
				// console.log(res);
				this.createCampana();
			});
		this.subscriptionpais = this._filtroPais.notifyObservable$.pipe(takeUntil(this.destroy$)).subscribe(
			res => {
				// console.log(res);
				this.idpais = res.IDPAIS;
				this.idpais = 5;
				this.get(0);
			}
		);
		this.idpais = 5;
	}

	// ============== FILTRO ==============
	filter = '';
	public keyDownFunction(event) {
		if (event.keyCode == 13) {
			this.filtrogeneral();
		} else if (event.keyCode == 8 && this.filter == '') {
			this.filtrogeneral();
		}
	}
	public filtrogeneral() {
		this._busqueda.notificarBusqueda({ filtro: this.filter });
	}

	ngAfterViewInit() {
		// console.log(this.localSave.get('nuevoUserPass'))

		if (this.localSave.get('nuevoUserPass') == 0) {
			setTimeout(() => {
				this.openPassword();
			})

		}
	}

	get(page) {
		// var params = { NUM_PAGINA: page, FILTRO: this.FILTER, NUM_ELEMENTOS: this.pageSize, IDPAIS: this.idpais, IDDISTRIBUIDOR: this.localSave.get('usuarioPGV').IDU };
		const params = { CANTIDAD: this.pageSize, FILTRO: this.filtercampana, PAGINA: page, IDPAIS: this.idpais, IDDISTRIBUIDOR: this.localSave.get('usuarioPGV').IDU }
		// console.log(params);
		this.spinner.show();
		this.gateway.get('getmensajerias', params).then((result: any) => {
			// console.log('||||||| MENSAJERIAS |||||||')
			// console.log(result);

			// var campanias = result.rows;
			// if (campanias.length > 0) {
			// 	campanias.forEach(campania => {
			// 		// console.log(campania);
			// 		campania.vigenciainicial = new Date(campania.vigenciainicial);
			// 		campania.vigenciafinal = new Date(campania.vigenciafinal);
			// 	});
			// }
			// this.dataSource = new MatTableDataSource(campanias);
			// this.gateway.get('getcampanacount', params).then((result: any) => {
			// 	//console.log(result.rows);
			// 	this.resultsLength = result.rows[0].total;
			// 	this.spinner.hide();
			// });

			// ===================== MENSAJERIA ========================
			let auxresult: any = result;
			this.dataSource = new MatTableDataSource(auxresult.mensajerias);
			this.resultsLength = auxresult.total[0].total;
			this.spinner.hide();

		}
		).catch(function (e) {
		});
	}
	ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
		this.subscription.unsubscribe();
		this.subscriptioncreate.unsubscribe();
		this.subscriptionpais.unsubscribe();
	}

	createCampana() {
		let newmensaje = {
			'idmensajeria': '',
			'nombre': '',
			'asunto': '',
			'pais': '',
			'tipo': '',
			'descripcion': '',
			'columnabi': { column_name: '', idcatalogo_criterio: 0, orden: 0, tabla: '', tipo: 0 },
			'condicion': '',
			'valoralfanumerico': '',
			'valorlistado': [],
			'frecuencias': [],
			'conservar': 0,
			'feriado': 0,
			'idcampana': 0,
		};
		const dialogRef = this.dialog.open(CreateMensajeriaComponent, {
			width: '760px',
			// width: '80%',
			// height: '94%',
			data: {
				title: 'Crear',
				IDPAIS: this.idpais,
				mensajeria: newmensaje
			},
			disableClose: true
		});

		dialogRef.afterClosed().subscribe(result => {
			// console.log('The dialog was closed');
			this.get(this.actpage);
		});
	}

	editarCamapana(mensajeria) {

		this.gateway.get('getmensajeriadetalle', { IDMENSAJERIA: mensajeria.idmensajeria }).then((result: any) => {
			// ===================== MENSAJERIA ========================
			let auxresult: any = result;

			mensajeria['pais'] = this.idpais;
			mensajeria.columnabi = mensajeria.columnabi ? mensajeria.columnabi : { column_name: '', idcatalogo_criterio: 0, orden: 0, tabla: '', tipo: 0 };
			mensajeria.frecuencias = mensajeria.frecuencias ? mensajeria.frecuencias : [];
			mensajeria.condicion = auxresult.CONDICIONES[0];
			mensajeria.frecuencias = auxresult.CONDICIONES[1];
			mensajeria.idmensajeria = auxresult.ENCABEZADO[0].idmensajeria;
			mensajeria.conservar = auxresult.ENCABEZADO[0].conservar;
			mensajeria.feriado = auxresult.ENCABEZADO[0].feriado;

			const dialogRef = this.dialog.open(CreateMensajeriaComponent, {
				width: '750px',
				// width: '80%',
				// height: '94%',
				data: {
					title: 'Editar',
					IDPAIS: this.idpais,
					mensajeria: mensajeria
				},
				disableClose: true
			});

			dialogRef.afterClosed().subscribe(result => {
				//console.log('The dialog was closed');
				//if (result) {
				this.get(this.actpage);
				//}
			});

		}
		).catch(function (e) {
		});
	}

	delete(element) {
		//console.log(element)

		const dialogRef = this.dialog.open(ConfirmacionComponent, {
			disableClose: true,
			width: '300px',
			data: { operacion: 'deletemensajeria', id: { IDMENSAJERIA: element.idmensajeria } }
		});

		dialogRef.afterClosed().subscribe(() => {
			this.mensajeriapaginator.firstPage();
			this.get(0);
		});
	}

	descargacampana(campana) {
		this.spinner.show();

		this.gateway.get('getarchivomensajeria', { IDMENSAJERIA: campana.idmensajeria, TIPO: campana.tipo })
		// this.gateway.get('exportarlistalote', { IDCAMPANA: campana.idcampana, LIMIT: 100, OFFSET: 0 })
		.then((result: any) => {
			if (campana.tipo == 6) {
				let auxresult: any = result;
				// var output = auxresult[0];
				let output = auxresult.rows;

				// console.log(output);

				const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(output);

				// generate workbook and add the worksheet
				const wb: XLSX.WorkBook = XLSX.utils.book_new();
				XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

				/* save to file */
				XLSX.writeFile(wb, 'Mensajeria_' + campana.nombre + '.xlsx');
				this.spinner.hide();
			} else {
				let auxresult: any = result;
				auxresult = auxresult.rows;
				const output = auxresult.map(function (obj) {
					return Object.keys(obj).map(function (key) {
						return obj[key];
					});
				});
				const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(output);
				// console.log(output);
				// const txt: string = XLSX.utils.sheet_to_txt(ws);
				/* generate workbook and add the worksheet */
				const wb: XLSX.WorkBook = XLSX.utils.book_new();

				XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

				/* save to file */
				XLSX.writeFile(wb, 'Mensajeria_' + campana.nombre + '.txt');
				this.spinner.hide();
			}
		}
		).catch(function (e) {
		});
	}

	// descargacampana(campana) {
	// 	// console.log(campana);
	// 	this.isLoadingResults = true;
	// 	this.Service.getArchivo({ DIM: campana.DIM, IDCAMPANA: campana.IDCAMPANA }).subscribe(
	// 	  result => {

	// 		if (campana.TIPO == 6) {
	// 		  let auxresult: any = result;
	// 		  var output = auxresult[0];

	// 		  // console.log(output);

	// 		  const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(output);

	// 		  // generate workbook and add the worksheet
	// 		  const wb: XLSX.WorkBook = XLSX.utils.book_new();
	// 		  XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

	// 		  /* save to file */
	// 		  XLSX.writeFile(wb, 'Campaña_' + campana.NOMBRE + '.xlsx');
	// 		  this.isLoadingResults = false;
	// 		} else {
	// 		  let auxresult: any = result;
	// 		  var output = auxresult[0].map(function (obj) {
	// 			return Object.keys(obj).map(function (key) {
	// 			  return obj[key];
	// 			});
	// 		  });
	// 		  const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(output);
	// 		  // console.log(output);
	// 		  // const txt: string = XLSX.utils.sheet_to_txt(ws);
	// 		  /* generate workbook and add the worksheet */
	// 		  const wb: XLSX.WorkBook = XLSX.utils.book_new();

	// 		  XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

	// 		  /* save to file */
	// 		  XLSX.writeFile(wb, 'Campaña_' + campana.NOMBRE + '.txt');
	// 		  this.isLoadingResults = false;
	// 		}

	// 	  },
	// 	  error => {
	// 		if (error.status == 405 || error.status == 401) {
	// 		  this.localSave.delete('user');
	// 		  this.router.navigate(['login']);
	// 		}
	// 	  }
	// 	);
	//   }

	cambioElementos(event?: PageEvent) {
		this.actpage = event.pageIndex;
		this.get(event.pageIndex);
	}

	addSchedule(campana) {

		this.localSave.set('campana', campana.IDCAMPANA);
		const dialogRef = this.dialog.open(CreateScheduleComponent, {
			maxWidth: '90vw',
			width: '620px',
			minHeight: '30vh',
			data: campana,
			disableClose: true
		});

		dialogRef.afterClosed().subscribe(result => {
			//console.log('The dialog was closed');
		});
	}

	addAlarm(campana) {

		this.localSave.set('campana', campana.IDCAMPANA);
		const dialogRef = this.dialog.open(CreateAlarmaComponent, {
			autoFocus: false,
			maxWidth: '90vw',
			width: '620px',
			minHeight: '30vh',
			data: campana,
			disableClose: true
		});

		dialogRef.afterClosed().subscribe(result => {
			// console.log('The dialog was closed');
		});
	}

	addCiclo(campana) {

		this.localSave.set('campana', campana.IDCAMPANA);
		const dialogRef = this.dialog.open(CreateCicloComponent, {
			autoFocus: false,
			maxWidth: '90vw',
			width: '620px',
			minHeight: '50vh',
			data: campana,
			disableClose: true
		});

		dialogRef.afterClosed().subscribe(result => {
			// console.log('The dialog was closed');
		});
	}

	addCriterio(campana) {

		this.localSave.set('campana', campana.IDCAMPANA);
		const dialogRef = this.dialog.open(CreateCriterioComponent, {
			autoFocus: false,
			maxWidth: '90vw',
			width: '620px',
			minHeight: '30vh',
			data: campana,
			disableClose: true
		});

		dialogRef.afterClosed().subscribe(result => {
			// console.log('The dialog was closed');
		});
	}

	filtrarcampana(data) {
		this.FILTER = data;
		this.get(0);
	}

	exportar(campana) {
		this.spinner.show();
		this.gateway.get('exportarlistacount', { IDCAMPANA: campana.idcampana }).then(
			(data: any) => {
				if (data.rows[0].cantidad > 0) {
					this.prepararinformacion(campana, data.rows[0].cantidad, 0, null);
				} else {
					this.snackbar.open('No hay clientes para esta mensajeria.', 'Cerrar', { duration: 3000, });
					this.spinner.hide();
				}
			}
		);
	}

	prepararinformacion(campana, count, index, data) {
		this.gateway.get('exportarlistalote', { IDCAMPANA: campana.idcampana, LIMIT: 100, OFFSET: index }).then(
			(result: any) => {
				if (data) {
					data = data.concat(result.rows)
				} else {
					data = result.rows;
				}
				let control = index + 100;
				if (control <= count) {
					this.prepararinformacion(campana, count, control, data);
				} else {
					this.descargarexcel(data, campana);
				}
			}
		);
	}

	descargarexcel(ctr, campana) {
		const fileName = 'Campana' + campana.nombre + '-' + Date.now();
		const wb: XLSX.WorkBook = XLSX.utils.book_new();
		const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(ctr);
		XLSX.utils.book_append_sheet(wb, ws);

		const wbout = XLSX.write(wb, { bookType: "xlsx", bookSST: false, type: "array" });
		saveAs(new Blob([wbout], { type: "application/octet-stream" }), fileName + ".xlsx");
		this.spinner.hide();
	}

	public async openPassword() {
		const agente = this.localSave.get('usuarioPGV');
		let dialogRef = await this.dialog.open(PasswordnewComponent, {
			width: '450px',
			disableClose: true,
			data: { title: 'Cambio de contraseña', agente: { idagente: agente.IDU } }
		});

		dialogRef.afterClosed().subscribe(result => {
		});
	}

	//----------------ASIGNA MASIVO------------------

	asignaMasivo() {
		document.getElementById("uploadfileasigna").click();
	}

	onFileChangeAsigna(evt: any) {
		let LISTA = [];

		this.spinner.show();

		let uploadname = evt.target.value.split('\\')[evt.target.value.split('\\').length - 1];

		// console.log(uploadname);

		/*    this.openclose=false;*/
		/* wire up file reader */
		const target: DataTransfer = <DataTransfer>(evt.target);
		if (target.files.length !== 1) throw new Error('Cannot use multiple files');
		const reader: FileReader = new FileReader();
		reader.onload = (e: any) => {
			/* read workbook */
			const bstr: string = e.target.result;
			const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });

			/* grab first sheet */
			const wsname: string = wb.SheetNames[0];
			const ws: XLSX.WorkSheet = wb.Sheets[wsname];
			/* save data */
			const dataexcel: any = XLSX.utils.sheet_to_json(ws, { header: 1 });
			(<HTMLInputElement>document.getElementById('uploadfileasigna')).value = null;
			// console.log(dataexcel);
			let csv = [];
			const flag = dataexcel[0];
			const bandera: number = 0;

			//validar columnas

			if (flag[0] === 'USUARIO' && flag[1] === 'CAMPAÑA' && flag[2] === 'CONTACTO' && flag[3] === 'EFECTIVIDAD'
				&& flag[4] === 'CONVERSION' && flag[5] === 'TMO(SEG)' && flag[6] === 'LLAMADAS' && flag[7] === 'CONTACTOS EFECTIVOS') {
				dataexcel.forEach((value) => {
					if (value[0] != 'USUARIO' && value[0] != '' && value[0] != undefined
						&& value[1] != 'CAMPAÑA' && value[1] != '' && value[1] != undefined
						&& value[2] != 'CONTACTO' && value[2] != '' && value[2] != undefined
						&& value[3] != 'EFECTIVIDAD' && value[3] != '' && value[3] != undefined
						&& value[4] != 'CONVERSION' && value[4] != '' && value[4] != undefined
						&& value[5] != 'TMO(SEG)' && value[5] != '' && value[5] != undefined
						&& value[6] != 'LLAMADAS' && value[6] != '' && value[6] != undefined
						&& value[7] != 'CONTACTOS EFECTIVOS' && value[7] != '' && value[7] != undefined) {
						LISTA.push({
							USUARIO: value[0], CAMPANA: value[1], CONTACTO: value[2], EFECTIVIDAD: value[3]
							, CONVERSION: value[4], TMO: value[5], LLAMADAS: value[6], CONTACTOS: value[7]
						});
					}
				});
				this.loadlistxlsAsigna(LISTA, 0);
			} else {
				this.snackbar.open('Formato de archivo no válido, porfavor intente con otro archivo.', 'CERRAR', { duration: 6000 });
				this.spinner.hide();
			}
		};
		reader.readAsBinaryString(target.files[0]);
	}

	loadlistxlsAsigna(LISTA, cantidad) {
		this.spinner.show();
		let auxarr = [];
		auxarr = LISTA.slice(cantidad, cantidad + 300);
		this.gateway.save('asignamasivaagentes', { IDCAMPANA: 10, LISTA: auxarr, IDDISTRIBUIDOR: this.localSave.get('usuarioPGV').IDU, IDPADRE: this.localSave.get('usuarioPGV').IDU, IDAREA: this.localSave.get('usuarioPGV').IDAREA }).then(
			res => {
				const resultado: any = res;
				if ((cantidad + 300) < LISTA.length) {
					this.loadlistxlsAsigna(LISTA, cantidad + 300);
				} else {
					this.spinner.hide();
					this.snackbar.open('Campañas asignadas con éxito: ' + resultado.agregados + ', campañas no asignadas: ' + resultado.noagregados, 'Cerrar', { duration: 5000, });
					this.get(this.actpage);
				}
			},
			err => {
				this.spinner.hide();
				this.snackbar.open('Los agentes no han sido asignados, intente nuevamente.', 'Cerrar', { duration: 5000, });
				// console.log(err);
			}
		);
	}
}

export interface Campana {
	ID_EJE: number,
	ID_CAMPANA: number,
	NOMBRE: string,
	NOMBREEJE: string,
	ESTADO: number,
	MEDIO: string,
	FECHAINICIAL: string,
	FECHAFINAL: string,
	SCRIPT: string,
	SCRIPTURL: string
}